export type CrudAction = 'create' | 'read' | 'update' | 'delete';
export type FieldAction = Exclude<CrudAction, 'delete'>;

export const crudActions = ['create', 'read', 'update', 'delete'] as const satisfies readonly CrudAction[];
export const fieldActions = ['create', 'read', 'update'] as const satisfies readonly FieldAction[];
